/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessReviewSessionPaginationSlice', 'model/BusinessReviewStep'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BusinessReviewSessionPaginationSlice'), require('./BusinessReviewStep'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewTemplateReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessReviewSessionPaginationSlice, root.ForStractionServiceApi.BusinessReviewStep);
  }
}(this, function(ApiClient, BusinessReviewSessionPaginationSlice, BusinessReviewStep) {
  'use strict';




  /**
   * The BusinessReviewTemplateReport model module.
   * @module model/BusinessReviewTemplateReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessReviewTemplateReport</code>.
   * @alias module:model/BusinessReviewTemplateReport
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>BusinessReviewTemplateReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessReviewTemplateReport} obj Optional instance to populate.
   * @return {module:model/BusinessReviewTemplateReport} The populated <code>BusinessReviewTemplateReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Sessions')) {
        obj['Sessions'] = BusinessReviewSessionPaginationSlice.constructFromObject(data['Sessions']);
      }
      if (data.hasOwnProperty('Steps')) {
        obj['Steps'] = ApiClient.convertToType(data['Steps'], [BusinessReviewStep]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Introduction')) {
        obj['Introduction'] = ApiClient.convertToType(data['Introduction'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('DateAdded')) {
        obj['DateAdded'] = ApiClient.convertToType(data['DateAdded'], 'Date');
      }
      if (data.hasOwnProperty('ShowMinimizeButton')) {
        obj['ShowMinimizeButton'] = ApiClient.convertToType(data['ShowMinimizeButton'], 'Boolean');
      }
      if (data.hasOwnProperty('DimmedBackground')) {
        obj['DimmedBackground'] = ApiClient.convertToType(data['DimmedBackground'], 'Boolean');
      }
      if (data.hasOwnProperty('WindowSizeID')) {
        obj['WindowSizeID'] = ApiClient.convertToType(data['WindowSizeID'], 'Integer');
      }
      if (data.hasOwnProperty('HideStepSelection')) {
        obj['HideStepSelection'] = ApiClient.convertToType(data['HideStepSelection'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/BusinessReviewSessionPaginationSlice} Sessions
   */
  exports.prototype['Sessions'] = undefined;
  /**
   * @member {Array.<module:model/BusinessReviewStep>} Steps
   */
  exports.prototype['Steps'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Introduction
   * @default ''
   */
  exports.prototype['Introduction'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Date} DateAdded
   */
  exports.prototype['DateAdded'] = undefined;
  /**
   * @member {Boolean} ShowMinimizeButton
   * @default false
   */
  exports.prototype['ShowMinimizeButton'] = false;
  /**
   * @member {Boolean} DimmedBackground
   * @default false
   */
  exports.prototype['DimmedBackground'] = false;
  /**
   * @member {Integer} WindowSizeID
   * @default 0
   */
  exports.prototype['WindowSizeID'] = 0;
  /**
   * @member {Boolean} HideStepSelection
   * @default false
   */
  exports.prototype['HideStepSelection'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


